import { useEffect, useState } from "react";
import { Container, TableContainerAnticipation, Button } from "../../styles";
import { T2 } from "../../../../styles/titles";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { AnticipationHistoryTableData, FormValuesHistory } from "./types";
import TransactionHistoryAnticipationService from "./service/transactionAnticipationHistoryService";
import { useParams } from "react-router-dom";
import Table, { TableColumn } from "../../../../components/Table";
import { formatMoney } from "../../../../utils/generalFormat";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useGetMe from "../../../../hooks/useCurrentUser";
import { can, PortalPermissions } from "../../../../config/permissions";

const TransactionAnticipationHistoryPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<AnticipationHistoryTableData>({
    records: [],
  });

  const { historyAnticipationId } = useParams<{
    historyAnticipationId: string;
  }>();
  console.log("historyAnticipationId:", historyAnticipationId);
  const transactionHistoryAnticipationService =
    new TransactionHistoryAnticipationService();
  const user = useGetMe();

  const formatDateView = (dateString: any) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const pad = (num: number) => (num < 10 ? `0${num}` : num);
    return `${pad(date.getUTCDate())}/${pad(
      date.getUTCMonth() + 1
    )}/${date.getUTCFullYear()}`;
  };

  const fetchAllData = async () => {
    if (!historyAnticipationId) return;

    setIsLoading(true);
    try {
      const response =
        await transactionHistoryAnticipationService.getTransactionAnticipation(
          Number(historyAnticipationId)
        );

      setTableData({
        records: response.data || [],
      });
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async (historyAnticipationId: number) => {
    if (!historyAnticipationId) return;

    try {
      setIsLoading(true);

      const response =
        await transactionHistoryAnticipationService.downloadTransactionHistoryAnticipationXls(
          historyAnticipationId
        );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = `Transações_Histórico_Anticipação_${historyAnticipationId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Erro ao baixar o arquivo:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (historyAnticipationId) {
      fetchAllData();
    }
  }, [historyAnticipationId]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button
          shape="circle"
          icon={<ArrowLeftOutlined style={{ color: "#000" }} />}
          onClick={() => window.history.back()}
          style={{
            backgroundColor: "#fff",
            border: "none",
            marginBottom: "4px",
            width: "40px",
            height: "40px",
          }}
        />
      </div>
      <T2>
        Histórico de Transações da Antecipação –{" "}
        {tableData.records.length > 0 ? tableData.records[0].merchantId : ""}
      </T2>
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        {can(PortalPermissions.cobrancas.historicoAntecipacao.exportar) && (
          <Button
            onClick={() =>
              handleDownload(tableData.records[0]?.historyAnticipationId)
            }
            style={{
              marginBottom: "12px",
              marginRight: "24px",
              width: "150px",
              alignSelf: "start",
            }}
          >
            Download xlsx
          </Button>
        )}
      </div>
      <TableContainerAnticipation>
        <Table dataSource={tableData.records}>
          <TableColumn title="NSU" dataIndex="nsu" key="nsu" />
          <TableColumn
            title="Autorização"
            dataIndex="authorization"
            key="authorization"
          />
          <TableColumn
            title="Parcela Atual"
            dataIndex="currentParcel"
            key="currentParcel"
          />
          <TableColumn
            title="Data de Pagamento"
            dataIndex="paymentDate"
            key="paymentDate"
            render={formatDateView}
          />
          <TableColumn
            title="Data Recebimento Original"
            dataIndex="originalReceiveDate"
            key="originalReceiveDate"
            render={formatDateView}
          />
          <TableColumn
            title="Nova Data Recebimento"
            dataIndex="newReceiveDate"
            key="newReceiveDate"
            render={formatDateView}
          />
          <TableColumn
            title="Valor Bruto"
            dataIndex="value"
            key="value"
            render={formatMoney}
          />
          <TableColumn
            title="Valor Líquido Original"
            dataIndex="originalLiquidValue"
            key="originalLiquidValue"
            render={formatMoney}
          />
          <TableColumn
            title="Novo Valor Líquido"
            dataIndex="newLiquidValue"
            key="newLiquidValue"
            render={formatMoney}
          />
          <TableColumn title="Número" dataIndex="number" key="number" />
          <TableColumn
            title="Dias Antecipados"
            dataIndex="anticipatedDays"
            key="anticipatedDays"
          />
          <TableColumn
            title="Valor Fator de Compra"
            dataIndex="purchasingFactorValue"
            key="purchasingFactorValue"
            render={formatMoney}
          />
          <TableColumn
            title="Valor Ad Valorem"
            dataIndex="adValoremValue"
            key="adValoremValue"
            render={formatMoney}
          />
          <TableColumn
            title="Impostos"
            dataIndex="totalIofValue"
            key="totalIofValue"
            render={formatMoney}
          />
          {user.userType === 3 && (
            <TableColumn
              title="Receita Transação"
              dataIndex="transactionRevenue"
              key="transactionRevenue"
              render={formatMoney}
            />
          )}

          <TableColumn
            title="Data Criação"
            dataIndex="created_At"
            key="created_At"
            render={formatDateView}
          />
        </Table>
      </TableContainerAnticipation>
    </Container>
  );
};

export default TransactionAnticipationHistoryPage;
